import { clamp, getPercentageValue, getPixelValue } from '~/utils/math';
import { TAG_OFFSET, TAG_SIZE } from '../constant';

/**
 * Tag position is the exact position where the user has clicked, it could be very close to the edges.
 * This function, re-calculate the position to move it off the edges and set the position to be exactly on the cicle of the tag icon.
 */
export const convertTagPosition = (
    percentageX: number,
    percentageY: number,
    boxWidth: number,
    boxHeight: number,
): {
    pctXAfterOffset: number;
    pctYAfterOffset: number;
} => {
    if (boxWidth === 0 && boxHeight === 0) {
        return {
            pctXAfterOffset: percentageX,
            pctYAfterOffset: percentageY,
        };
    }

    // Give the pixel position based on the current image size
    const posXBeforeOffset = getPixelValue(percentageX, boxWidth);
    const posYBeforeOffset = getPixelValue(percentageY, boxHeight);

    // Move tag to be positioned on the circle of the tag icon
    let markerX = posXBeforeOffset - TAG_OFFSET;
    let markerY = posYBeforeOffset - TAG_OFFSET;

    // Re-position tag close to the edges to avoid being out of the image box
    markerX = clamp(markerX, 0, boxWidth - TAG_SIZE);
    markerY = clamp(markerY, 0, boxHeight - TAG_SIZE);

    // Convert to percentages
    const pctXAfterOffset = getPercentageValue(markerX, boxWidth);
    const pctYAfterOffset = getPercentageValue(markerY, boxHeight);

    return {
        pctXAfterOffset,
        pctYAfterOffset,
    };
};
